import {
    computed,
    defineComponent
} from "vue";
import { useRoute } from "vue-router";
import { MarkdownDoc } from "./MarkdownDoc.js";
import {
    getLegalDoc,
    getLegalDocContent,
    LegalDocs
} from "./legalContent.js";
import {
    PublicFooter,
    PublicNavbar,
    usePublicLocalizedPath,
} from "./PublicShell.js";
import { useLocale } from "../../locales/i18n.js";


//////////////////////////////////////////////////
//  LEGAL PAGE
//////////////////////////////////////////////////


export default defineComponent({
    setup() {
        const route = useRoute();
        const { i18n, locale } = useLocale();
        const publicPath = usePublicLocalizedPath();

        const doc = computed(() => {
            const slug = typeof route.name === "string"
                ? route.name
                : "";

            return getLegalDoc(slug);
        });

        return () => {
            const currentDoc = doc.value;

            if (!currentDoc) {
                return (
                    <div class="public-page">
                        <PublicNavbar />

                        <div class="public-doc-not-found">
                            <span class="landing-kicker">{i18n("legal.not_found.kicker")}</span>
                            <h1>{i18n("legal.not_found.title")}</h1>
                            <p>{i18n("legal.not_found.description")}</p>

                            <router-link class="landing-button landing-button-dark" to={publicPath("/docs")}>
                                {i18n("docs.not_found.action")}
                                <i class="material-symbols-outlined">arrow_back</i>
                            </router-link>
                        </div>

                        <PublicFooter />
                    </div>
                );
            }

            return (
                <div class="public-page">
                    <PublicNavbar />

                    <div class="public-doc-layout">
                        <div class="public-doc-sidebar">
                            <router-link class="public-doc-back" to={publicPath("/docs")}>
                                <i class="material-symbols-outlined">arrow_back</i>
                                {i18n("docs.all_manuals")}
                            </router-link>

                            <div class="public-doc-sidebar-title">{i18n("docs.sidebar.legal")}</div>

                            {LegalDocs.map((item) => (
                                <router-link class="public-doc-sidebar-link" to={publicPath(`/${item.slug}`)}>
                                    <i class="material-symbols-outlined">{item.icon}</i>
                                    <span>{i18n(item.titleKey)}</span>
                                </router-link>
                            ))}
                        </div>

                        <div class="public-doc-article">
                            <div class="public-doc-header">
                                <div class="manual-card-icon">
                                    <i class="material-symbols-outlined">{currentDoc.icon}</i>
                                </div>

                                <span class="landing-kicker">{i18n(currentDoc.categoryKey)} · {i18n(currentDoc.readTimeKey)}</span>
                                <h1>{i18n(currentDoc.titleKey)}</h1>
                                <p>{i18n(currentDoc.descriptionKey)}</p>
                            </div>

                            <MarkdownDoc markdown={getLegalDocContent(currentDoc, locale.value)} />
                        </div>
                    </div>

                    <PublicFooter />
                </div>
            );
        };
    },
});
